import styles from './styles.module.scss'

import Button from '@/components/Button'

interface QuickLinkCardProps {
  title: string
  subtitle: string
  ctaLabel: string
  to: string
  onClick?: () => void
}

export const QuickLinkCard = ({ title, subtitle, ctaLabel, to, onClick }: QuickLinkCardProps) => (
  <div className={styles.card}>
    <div className={styles.content}>
      <span className={styles.title}>{title}</span>
      <span className={styles.subtitle}>{subtitle}</span>
    </div>
    <Button title={ctaLabel} type="light" to={to} onClick={onClick} className={styles.cta} />
  </div>
)
